// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React, {useEffect, useState} from 'react';
import * as config from '../../config';

// Components
import Navigation from '../Navbar/Navbar';
import VideoPlayer from '../VideoPlayerReact/VideoPlayer';
import ProductList from '../productList/ProductList';

// Styles
import './WebECommerce.css';
import {GetCurrency, GetDataFile, GetProductsFile, GetVideoFile} from "../../utility/Utils";
import {useParams} from "react-router-dom";
import styles from "../../pages/Home.module.css";

const WebECommerce = () => {

  const [currentProductId, setCurrentProductId] = useState('')
  const [showModal, setShowModal] = useState(false)

  const [response, setResponse] = useState({});
  const [apiFetched, setApiFetched] = useState(false);

  let {id, dir} = useParams();


  const fetchAPI = async () => {

    const response1 =  await fetch(GetDataFile(dir,id));

    const data = await response1.json();

    const response2 = await fetch(GetProductsFile(dir,id));
    const details = await response2.json();

    const response = {}
    response['playbackUrl'] = GetVideoFile(dir,id)
    response['title'] = details["title"]
    response['subtitle'] = details["subtitle"]
    response['fps'] = details["fps"]
    response['currency'] = GetCurrency(details["currency"])
    response['length'] = '100'
    response['data'] = data
    response['products'] = details["products"]

    setResponse(response);
    setApiFetched(true);

  }

  useEffect(() => {
    // Set mounted to true so that we know when first mount has happened
    let mounted = true;

    if (mounted && !apiFetched) {
      fetchAPI()
    }

    // Set mounted to false when the component is unmounted
    return () => {
      mounted = false
    };
  });

  const handleECommerceOnClick = () => {
    if (showModal) {
      setShowModal(false);
    }
  }

  const details = showModal ? 'details' : '';
  return (
    <div className={`web-ecommerce-container full-width full-height ${details}`} onClick={handleECommerceOnClick}>
      <Navigation />
      <div className="web-ecommerce-content pd-2 grid fl fl-j-center">
        <div className="video-product-content">
          <VideoPlayer setMetadataId={setCurrentProductId}
                       videoStream={GetVideoFile(dir,id)}
                       partner={dir}
                       videoId={id}
                       data={response['data']}
                       products={response['products']}
                       fps={response['fps']}
                       currency={response['currency']}
                       controls={true}
                       imageUrl={`${config.S3_URL}/${dir}/${id}`}
          />
          <ProductList
            currentProductId={currentProductId}
            setModal={setShowModal}
            showModal={showModal}
            currency={response['currency']}
            products={response['products']}
            s3path={`${config.S3_URL}/${dir}/${id}/`}
          />

        </div>
        <div className="web-ecommerce-content pd-2 grid fl fl-j-left">

          <h1 className={styles.h1}>{response['title']}</h1>
          <p className="mg-t-1 color-alt">{response["subtitle"]}</p>
        </div>
      </div>

    </div>
  )
}

export default WebECommerce;
